import { gql } from '@apollo/client';

export const fetchAddOnsParentEntitlementV2 = gql`
  query fetchAddOnsParentEntitlementV2($id: String) {
    entitlementDetails(id: $id) {
      id
      billingCycle
      billingStatus
      entitlementNumber
      latestPeriodEndDate
      latestPeriodStartDate
      offeringId
      productName
      sourceSystem
      plan
      edition
      cloudSiteHostname
      billingGroupId
      productId
      provisioningStatus
      subscriptionTimestamps {
        firstStartTimestamp
        lastEndTimestamp
        firstTrialStartTimestamp
        lastTrialEndTimestamp
      }
      isSandbox
    }
  }
`;
